import { useTranslation } from 'react-i18next';
import classes from './Banner.module.scss';
import image from '../../../assets/img/Faqs/Banner/image.webp';
import image_mob from '../../../assets/img/Faqs/Banner/image-mob.webp';

const Banner = () => {
    const { t } = useTranslation();
    return (
        <section className="container">
            <div className={classes.wrap}>
                <div className={classes.head}>
                    <h1 className={`${classes.title} font-48`}>
                        {t('faqs.banner.title')}
                    </h1>
                </div>
                <p className={`${classes.text} font-16`}>
                    {t('faqs.banner.text')}
                </p>
                <img className={classes.image} src={image} alt='' />
                <img className={classes.image_mob} src={image_mob} alt='' />
            </div>
        </section>
    );
};

export default Banner;
